export default __webpack_public_path__ + "static/media/thunder-logo.49b4a517.svg";